import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  modalContainer: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  modal: {
    maxHeight: '290px',
    maxWidth: '690px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 20px',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto',
  },
  modalTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  modalTitleAndIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  modalDeleteBody: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    flex: 1,
    padding: '20px 0',
  },
  modalButtonsContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
}));

export default useStyles;
